import { useState, useEffect } from 'react'
import { post } from '@api/apiFetcher'

function withOfferIncreaseView (TargetComponent) {
    return function offerIncreaseView (props) {
        const [done, setDone] = useState(false)

        useEffect(() => {
            const { type, _shortid } = props.offer || {}
            if (type && _shortid && !done) {
                const path = `/api/offers/${type}/${_shortid}/hit_view`
                post({ path, data: { inc: 1 }})
                    .then(res => null)
                setDone(true)
            }
        }, [])

        return <TargetComponent {...props} />
    }
}

export default withOfferIncreaseView